export default {
  // Properties panel translation.
  General: "Geral",
  Variables: "Variáveis",
  Connector: "Conector",
  Forms: "Formulários",
  Listeners: "Ouvintes",
  "Input/Output": "Entrada / Saída",
  Extensions: "Extensões",
  "camunda-id": "Id",
  Name: "Nome",
  "Element Template": "Modelo de elemento",
  Implementation: "Implementação",
  "Version Tag": "Tag da versão",
  Executable: "Executável",
  "Result Variable": "Variável de resultado",
  Topic: "Tópico",
  "Task Priority": "Prioridade da tarefa",
  "Asynchronous Before": "Antes assíncrono",
  "Asynchronous After": "Após assíncrono",
  Exclusive: "Exclusivo",
  "Job Priority": "Prioridade de trabalho",
  "Element Documentation": "Documentação do elemento",
  "Connector Id": "ID do conector",
  "Input Parameters": "Parâmetros de entrada",
  "Output Parameters": "Parâmetros de saída",
  "camunda-connector-parameterName": "Name",
  Type: "Tipo",
  Value: "Valor",
  "Script Format": "Formato do script",
  "Script Type": "Tipo de script",
  Resource: "Recurso",
  Script: "Script",
  "Event Type": "Tipo de evento",
  "Listener Type": "Tipo de ouvinte",
  "Parameter must have a name": "O parâmetro deve ter um nome",
  "Must provide a value": "Deve fornecer um valor",
  Text: "Texto",
  List: "Lista",
  Map: "Mapa",
  "Inline Script": "Script embutido",
  "External Resource": "Recurso externo",
  start: "inicio",
  end: "fim",
  "Java Class": "Classe Java",
  Expression: "Expressão",
  "Delegate Expression": "Delegar expressão",
  External: "Externo",
  "Add Execution Listener": "Adicionar ouvinte de execução ",
  "cam-extensionElements-inputs": "Input Parameters",
  "cam-extensionElements-outputs": "Output Parameters",
  "camunda-parameterName": "Name",
  "camunda-parameterType": "Type",
  "camunda-parameterType-text": "Value",
  Initiator: "Iniciador",
  "Form Type": "Tipo de formulário",
  "Form Key": "Chave do formulário",
  "Form Keys": "Chaves dos formulários",
  "Model type": "Tipo de modelo",
  State: "Estado",
  "Schema type": "Tipo de esquema",
  "Schema name": "Nome do esquema",
  Comment: "Comentário",
  "Script language": "Linguagem de script",
  "Process type": "Tipo de processo",
  "Model name": "Nome do modelo",
  "Custom Fields": "Os campos personalizados",
  Details: "Detalhes",
  "External Task Configuration": "Configuração de Tarefa Externa",
  "Multi Instance": "Multiplas Instâncias",
  "Asynchronous Continuations": "Continuações assíncronas",
  "Job Configuration": "Configuração do trabalho",
  Documentation: "Documentação",
  //'input/output': 'Input/Output',
  "Execution Listeners": "Ouvintes de execução",
  "Execution Listener": "Ouvinte de Execução",
  "Task Listeners": "Ouvintes de tarefas",
  Parameters: "Parâmetros",
  Properties: "Propriedades",
  "Input Parameter": "Parâmetro de entrada",
  "Add Value": "Adicionar valor",
  "Add Entry": "Adicionar entrada",
  "Add Property": "Adicionar Propriedade",
  "Candidate Starter Configuration": "Configuração do candidato iniciante",
  "Candidate Starter Groups": "Grupos candidatos",
  "Candidate Starter Users": "Usuários candidatos",
  "History Configuration": "Configuração do histórico",
  "History Time To Live": "Hora da História",
  "Tasklist Configuration": "Configuração da lista de tarefas",
  Startable: "Iniciável",
  "Field Injection": "Injeção em Campo",
  Fields: "Campos",
  "Open minimap": "Abrir minimapa",
  "Form Fields": "Campos do formulário",
  "Form Field": "Campo do formulário",
  "Business Key": "Chave comercial",
  Label: "Rótulo",
  "Default Value": "Valor padrão",
  Validation: "Validação",
  "Add Constraint": "Adicionar restrição",
  "Properties Smart": "Propriedades Smart",
  "Field properties": "Propriedades do campo",
  "Smart Types": "Tipos Smart",
  //'name': 'Name',

  // Labels
  "This maps to the process definition key.":
    "Isso mapeia para a chave de definição de processo.",
  "Specify more than one group as a comma separated list.":
    "Especifique mais de um grupo como uma lista separada por vírgula.",
  "Specify more than one user as a comma separated list.":
    "Especifique mais de um usuário como uma lista separada por vírgula.",
  "Activate the global connect tool": "Ativar ferramenta de conexão global",
  "Append {type}": "Anexar {type}",
  "Add Lane above": "Adicionar via acima",
  "Divide into two Lanes": "Dividir in duas vias",
  "Divide into three Lanes": "Dividir in três vias",
  "Add Lane below": "Adicionar via abaixo",
  "Append compensation activity": "Anexar atividade de compensação",
  "Append Intermediate/Boundary Event": "Anexar Evento Intermediário/Limite",
  "Append Gateway": "Anexar Gateway",
  "Change type": "Mudar tipo",
  "Connect using Association": "Conectar usando associação",
  "Connect using Sequence/MessageFlow or Association":
    "Conectar usando Sequência/Fluxo de Mensagem ou Associação",
  "Connect using DataInputAssociation":
    "Conectar usando Entrada de Dados de Associação",
  Remove: "Excluir",
  "Activate the hand tool": "Atvar ferramenta de mão",
  "Activate the lasso tool": "Ativar ferramenta de laço",
  "Activate the create/remove space tool":
    "Ativar add/excluir ferramenta espacial",
  "Create expanded SubProcess": "Criar SubProcesso expandido",
  "Create IntermediateThrowEvent/BoundaryEvent":
    "Criar IntermediateThrowEvent/BoundaryEvent",
  "Create Intermediate/Boundary Event": "Criar evento Intermediate/Boundary ",
  "Create Pool/Participant": "Criar Pool / Participante",
  "Create Start Timer Event": "Criar Evento de Início de Tempo",
  "Create Gateway": "Criar Gateway",
  "Parallel Multi Instance": "Instância Multi Paralela",
  "Sequential Multi Instance": "Instância Multi Sequencial",
  Loop: "Loop",
  "Ad-hoc": "Ad-hoc",
  "Create {type}": "Criar {type}",
  Task: "Tarefa",
  "Send Task": "Enviar Tarefa",
  "Receive Task": "Excluir Tarefa",
  "User Task": "Tarefa de Usuário",
  "Manual Task": "Tarefa Manual",
  "Business Rule Task": "Tarefa de Regra de Negócio",
  "Service Task": "Tarefa do tipo Serviço",
  "Script Task": "Tarefa de Roteiro",
  "Call Activity": "Atividade de Ligar",
  "Sub Process (collapsed)": "Sub Processo (agrupado)",
  "Start Event": "Iniciar Evento",
  "Intermediate Throw Event": "Evento de Lançamento Intermediário",
  "End Event": "Finalizar Evento",
  "Message Start Event": "Evento de Início da Mensagem",
  "Timer Start Event": "Evento de Início do Timer",
  "Conditional Start Event": "Evento de Início Condicional",
  "Signal Start Event": "Evento de início de sinal",
  "Error Start Event": "Evento de início de erro",
  "Escalation Start Event": "Evento inicial de escalonamento",
  "Compensation Start Event": "Evento de Início da Compensação",
  "Message Start Event (non-interrupting)":
    "Evento de Início da Mensagem (sem-interrupção)",
  "Timer Start Event (non-interrupting)":
    "Evento de Início do Timer (sem-interrupção)",
  "Conditional Start Event (non-interrupting)":
    "Evento de Início Condicional (sem-interrupção)",
  "Signal Start Event (non-interrupting)":
    "Evento de início de sinal (sem-interrupção)",
  "Escalation Start Event (non-interrupting)":
    "Evento inicial de escalonamento (sem-interrupção)",
  "Message Intermediate Catch Event": "Mensagem Intermediária Catch Event",
  "Message Intermediate Throw Event":
    "Evento de Lançamento Intermediário de Mensagem",
  "Timer Intermediate Catch Event": "Timer Intermediate Catch Event",
  "Escalation Intermediate Throw Event":
    "Evento de lançamento intermediário de escalonamento",
  "Conditional Intermediate Catch Event":
    "Evento de Captura Intermediária Condicional",
  "Link Intermediate Catch Event": "Link Intermediate Catch Event",
  "Link Intermediate Throw Event": "Link Evento de Lançamento Intermediário",
  "Compensation Intermediate Throw Event":
    "Evento de Lançamento Intermediário de Compensação",
  "Signal Intermediate Catch Event": "Evento de Erro Intermediário",
  "Signal Intermediate Throw Event": "Evento de Lançamento Intermediário",
  "Message End Event": "Evento de fim da mensagem",
  "Escalation End Event": "Evento Final de Escalonamento",
  "Error End Event": "Evento Final do Erro",
  "Cancel End Event": "Cancelar evento final",
  "Compensation End Event": "Evento de Fim de Compensação",
  "Signal End Event": "Evento Final do Sinal",
  "Terminate End Event": "Terminate End Event",
  "Message Boundary Event": "Evento de Mensagem de Fronteira",
  "Message Boundary Event (non-interrupting)":
    "Evento de Mensagem de Fronteira (sem interrupção)",
  "Timer Boundary Event": "Evento de Limite de Temporarizador",
  "Timer Boundary Event (non-interrupting)":
    "Evento de Limite de Temporarizador (sem interrupção)",
  "Escalation Boundary Event": "Evento de limite de escalonamento",
  "Escalation Boundary Event (non-interrupting)":
    "Evento de limite de escalonamento (sem interrupção)",
  "Conditional Boundary Event": "Evento de limite condicional",
  "Conditional Boundary Event (non-interrupting)":
    "Evento de limite condicional (sem interrupção)",
  "Error Boundary Event": "Evento de limite de erro",
  "Cancel Boundary Event": "Cancelar evento de limite",
  "Signal Boundary Event": "Evento de limite de sinal",
  "Signal Boundary Event (non-interrupting)":
    "Evento de limite de sinal (sem interrupção)",
  "Compensation Boundary Event": "Evento de Limite de Compensação",
  "Exclusive Gateway": "Gateway Exclusivo",
  "Parallel Gateway": "Gateway Paralelo",
  "Inclusive Gateway": "Gateway Inclusivo",
  "Complex Gateway": "Gateway Complexo",
  "Event based Gateway": "Gateway baseado em eventos",
  Transaction: "Transação",
  "Sub Process": "Subprocesso",
  "Event Sub Process": "Evento de Subprocesso",
  "Collapsed Pool": "Pool Fechado",
  "Expanded Pool": "Pool Expandido",

  // Errors
  "no parent for {element} in {parent}":
    "sem elemento pai para {element} em {parent}",
  "no shape type specified": "tipo da forma não especificado",
  "flow elements must be children of pools/participants":
    "elementos flow devem ser filhos de pools/participantes",
  "out of bounds release": "release fora dos limites",
  "more than {count} child lanes": "mais de {count} faixas filhas",
  "element required": "elemento requerido",
  "diagram not part of bpmn:Definitions":
    "diagram nao atende as bpmn:Definitions",
  "no diagram to display": "sem diagrama para exibir",
  "no process or collaboration to display":
    "sem processos ou colaboração a exibir",
  "element {element} referenced by {referenced}#{property} not yet drawn":
    "elemento {element} referenciado por {referenced}#{property} não está pronta para desenhar",
  "already rendered {element}": "{element} já renderizado",
  "failed to import {element}": "falha na importaçao de {element}",

  //itens smart
  "Read Only": "Somente leitura",
  "Sets a value indicating whether this element is enabled in the user interface.":
    "Define um valor indicando se esse elemento está ativado na interface do usuário.",
  Tooltip: "Dica",
  "Sets a tooltip message that is displayed for this element in the user interface.":
    "Define uma mensagem de dica de ferramenta que é exibida para esse elemento na interface do usuário.",
  "Regular Expression": "Expressão regular",
  "Sets a regex validation that will apply before submitting the form.":
    "Define uma validação de regex que será aplicada antes de enviar o formulário.",
  "Regex Message": "Mensagem Regex",
  "Sets a regex error message that is displayed for this element in the user interface.":
    "Define uma mensagem de erro de regex que é exibida para esse elemento na interface do usuário.",
  Required: "Requerido",
  "Sets that an input field must be filled out before submitting the form. Show a defined message when is not filled.":
    "Define que um campo de entrada deve ser preenchido antes de enviar o formulário. Mostrar uma mensagem definida quando não estiver preenchida. ",
  "Show Field": "Mostrar campo",
  "Defines that indicates whether this element will be visible in the Task List.":
    "Define que indica se esse elemento estará visível na lista de tarefas.",
  "OnBlur API": "API OnBlur",
  "Defines that this element will go to receive custom information from a web API. Must provide a URL path.":
    "Define que esse elemento irá receber informações personalizadas de uma API da web. Deve fornecer um caminho de URL. ",
  "Multi Line": "Multi Line",
  "Defines a multi-line text input control.":
    "Define um controle de entrada de texto com várias linhas.",
  Rows: "Linhas",
  "Sets the maximum number of visible lines to size to.":
    "Define o número máximo de linhas visíveis para o tamanho.",
  "Supplemental info": "Informações suplementares",
  "Displays supplemental information in the user interface.":
    "Exibe informações suplementares na interface do usuário.",
  History: "Histórico",
  "Displays a history in the user interface.":
    "Exibe um histórico na interface do usuário.",
  Upload: "Upload",
  "Premite o upload de documentos": "Premite o upload de documentos",
  "Accepted Files": "Arquivos permitidos",
  "Defines the types of documents allowed on upload.":
    "Define os tipos de documentos permitidos no upload.",
  "Documents Types": "Tipos de documentos",
  "Read Only (Document Type)": "Somente Leitura (Tipos de Documento)",
  "Sets a web APi URL that returns the documents types that will be list in the user interface.":
    "Define um URL da APi da web que retorna os tipos de documentos que serão listados na interface do usuário.",
  "Sets the documents types list is enabled in the user interface.":
    "Define que a lista de tipos de documentos está ativada na interface do usuário.",
  "Technical Advice": "Parecer técnico",
  "Read Only (Technical Advice)": "Somente Leitura (Parecer técnico)",
  "Sets a web APi URL that returns the Technical Advice that will be list in the user interface.":
    "Define um URL da APi da web que retorna o parecer técnico que será listado na interface do usuário.",
  "Sets the Technical Advice list is enabled in the user interface.":
    "Define que a lista de pareceres técnicos está ativada na interface do usuário.",
  Content: "Conteúdo",
  "Sets the custom user interface.":
    "Define a interface do usuário personalizada.",
  "Generated Forms fields": "Campos de formulários gerados",
  Copy: "Copiar",
  Cancel: "Cancelar",
  "Show Images": "Visualizar Imagens",
  "Sets the Image Viewer is enabled in the user interface.":
    "Define que o Image Viewer está ativado na interface do usuário.",
  "Thousand Separator": "Separador de milhar",
  "Add thousand separators on number": "Adicione separador de milhar ao número",
  "Decimal Separator": "Separador decimal",
  "Support decimal point on a number": "Suporte a número decimal",
  "Decimal Scale": "Escala decimal",
  "If defined it limits to given decimal scale":
    "Define qual o limite de escala decimal",
  "Allow Negative": "Permite negativo",
  "Alow negative numbers": "Permite nímeros negativos",
  "Signature required": "Assinatura do documento obrigatória",
  "Sets that an PDF file must be signature out before submitting the form. Show a defined message when is not filled.":
    "Define que um arquivo PDF deve ser assinado antes de enviar o formulário. Mostrar uma mensagem definida quando não estiver preenchida.",
  "Signature task required": "Assinatura da tarefa obrigatória",
  "Sets that an task must be signature out before submitting the form. Show a defined message when is not filled.":
    "Define que uma tarefa deve ser assinada antes de enviar o formulário. Mostrar uma mensagem definida quando não estiver preenchida.",
  Assignee: "Cessionário",
  assignee: "cessionário",
  "Candidate Users": "Usuários Candidatos",
  "Candidate Groups": "Grupos Candidatos",
  "Due Date": "Data de Vencimento",
  // eslint-disable-next-line no-template-curly-in-string
  "The due date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)":
    "A data de vencimento como uma expressão EL (por exemplo, $ {someDate} ou uma data ISO (por exemplo, 2015-06-26T09: 54: 00)", // eslint-disable-line no-template-curly-in-string
  "Follow Up Date": "Data de acompanhamento",
  // eslint-disable-next-line no-template-curly-in-string
  "The follow up date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)":
    "A data de acompanhamento como uma expressão EL (por exemplo, $ {someDate} ou uma data ISO (por exemplo, 2015-06-26T09: 54: 00)", // eslint-disable-line no-template-curly-in-string
  Priority: "Prioridade",
  "This maps to the task definition key.":
    "Isso mapeia para a chave de definição de tarefa.",
  "Output Parameter": "Parâmetro de saída",
  Message: "Mensagem",
  "Message Name": "Nome da Mensagem",
  "Timer Definition Type": "Tipo de definição do temporizador",
  Date: "Data",
  Duration: "Duração",
  Cycle: "Ciclo",
  "Timer Definition": "Definição do temporizador",
  "Retry Time Cycle": "Ciclo de tempo de repetição",
  "Variable Name": "Nome da variável",
  "Condition Type": "Tipo de condição",
  Signal: "Sinal",
  "Signal Name": "Nome do sinal",
  Escalation: "Escalonamento",
  "Escalation Name": "Nome do escalonamento",
  "Escalation Code": "Código de escalonamento",
  "Escalation Code Variable": "Variável de código de escalonamento",
  "Variable Event": "Evento da variável",
  "Specify more than one variable change event as a comma separated list.":
    "Especifique mais de um evento de alteração de variável como uma lista separada por vírgula.",
  "Link Name": "Nome do Link",
  "Wait for Completion": "Aguardar conclusão",
  "Activity Ref": "Ref. da atividade",
  "Append TimerIntermediateCatchEvent":
    "Anexar evento de captura intermediária do timer",
  "Append MessageIntermediateCatchEvent":
    "Anexar Evento de Captura Intermediário da Mensagem",
  "Append ConditionIntermediateCatchEvent":
    "Anexar evento de captura intermediária da condição",
  "Append SignalIntermediateCatchEvent":
    "Anexar Evento de Captura Intermediário de Sinal",
  TextAnnotation: "Anotação de texto",
  "Set Color": "Definir cor",
  Red: "Vermelho",
  Orange: "Laranja",
  Yellow: "Amarelo",
  Green: "Verde",
  Blue: "Azul",
  Indigo: "Índigo",
  Violet: "Violeta",
  "Must configure Connector": "É necessário configurar o Connector",
  "Decision Ref": "Referência da Decisão",
  Binding: "Obrigatória",
  latest: "Mais recentes",
  deployment: "desenvolvimento",
  version: "versão",
  Version: "Versão",
  versionTag: "Tag da versão",
  "Tenant Id": "Identificação do Tenant",
  "CallActivity Type": "Tipo de atividade de chamada",
  "Called Element": "Elemento chamado",
  "Delegate Variable Mapping": "Delegar mapeamento de variável",
  "In Mapping": "Mapeamento de entrada",
  "Out Mapping": "Mapeamento de saída",
  Source: "Fonte",
  "Source Expression": "Expressão de origem",
  "Mapping must have a {value}": "O mapeamento deve ter uma {value}",
  "Mapping must have a value": "O mapeamento deve ter um valor",
  Target: "Alvo",
  "Mapping must have a target": "O mapeamento deve ter um alvo",
  "Target must not contain whitespace":
    "O alvo não pode conter espaços em branco",
  Class: "Classe",
  "Process Name": "Nome do processo",
  "Process Id": "Id do processo",
  "Process Documentation": "Documentação do processo",
  variableMappingClass: "Classe",
  variableMappingDelegateExpression: "Expressão",
  "{label} must not contain whitespace":
    "{label} não deve conter espaço em branco",
  All: "Todas",
  Error: "Erro",
  "Error Name": "Nome do erro",
  "Error Code": "Código de erro",
  "Error Message": "Menssagem de erro",
  "Error Code Variable": "Variável de código de erro",
  "Error Message Variable": "Variável da mensagem de erro",
  "Category Value": "Valor da categoria",
  "Task Listener": "Listener de tarefas",
  "Field Injections": "Injeções de campo",
  "[unknown template: {templateId}]": "[modelo desconhecido: {templateId}]",
  "Custom Fields for scope: ": "Campos personalizados para o escopo:",
  "Must not be empty": "Não deve ser em branco",
  "Must have max length {length}": "Deve ter comprimento máximo {length}",
  "Must have min length {length}": "Deve ter comprimento mínimo {length}",
  "Must match pattern {pattern}": "Deve corresponder ao padrão {pattern}",
  Condition: "Condição",
  Config: "Configuração",
  Values: "Valores",
  "Case Ref": "Referência de Caso",
  "Business Key Expression": "Expressão da chave comercial",
  "Map Decision Result": "Resultado da Decisão do Mapa",
  "Name must not contain spaces": "O nome não deve conter espaços",
  "Must provide either loop cardinality or collection":
    "Deve fornecer cardinalidade ou coleção de loop",
  "Loop Cardinality": "Cardinalidade de loop",
  Collection: "Coleção",
  "Element Variable": "Elemento variável",
  "Completion Condition": "Condição de conclusão",
  take: "levar",
  create: "criar",
  assignment: "atribuição",
  complete: "completar",
  delete: "deletar",
  "Multi Instance ": "Multi-instância ",
  "Configure Connector": "Configurar conector",
  "Element must have an unique id.": "O elemento deve ter um ID exclusivo.",
  "Id must not contain spaces.": "Id não deve conter espaços.",
  "Id must not contain prefix.": "Id não deve conter prefixo.",
  "Id must be a valid QName.": "Id deve ser um QName válido.",
  "Config SmartRules": "Configurar o smartRules",
  Category: "Categoria",
  Description: "Descrição",
  "Available process variables, identified in the diagram.":
    "Variáveis de processo disponíveis, identificadas no diagrama.",
  "No variables found.": "Nenhuma variável encontrada.",
  Edit: "Editar",
  "Add Form": "Adicionar formulário",
  Delete: "Excluir",
  Signature: "Assinatura",
  "Documents for signature": "Documentos para assinatura",
  "External Portal": "Portal Externo",
  "Automatic Process": "Processo automático"
};
